import React from 'react';

const BlogCardClassic = ({ data }) => {
    const { img, author, title } = data;

    return (
        <div className="col-lg-4 col-md-4">
            <article className="blog_post">
                <div className="post_img">
                    <img src={img} alt="blog" />
                    <div className="calendar">
                        <a href="#">Aug <br /> <span className="date">06</span></a>
                    </div>
                </div>
                <div className="post_content">
                    <div className="post_header">
                        <div className="metalist">
                            <span className="author"><a href="#">{author}</a></span>
                        </div>
                        <h3 className="post_title">
                            <a href="/blog-details">{title}</a>
                        </h3>
                    </div>
                    <div className="post_intro">
                        <p>Lorem ipsum dolor sit amet, consectetur mod tempor indid unt ut labore et dolore dolor sit amet, consectetur moindid unt ut labore et dolore...</p>
                    </div>
                    <div className="post_footer">
                        <div className="read_more">
                            <a href="/blog-details">See More</a>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    );
};

export default BlogCardClassic;